export default __webpack_public_path__ + "static/media/banco14.01af3462.png";